import { TransactionHistoryResponseModel } from "app/based/baseApiModel/baseTransactionHistory/TransactionHistoryResponseModel";

import isEmpty from "lodash/isEmpty";
export class BalanceHistoryActionEntity {
  code?: string;
  status?: number;
  amount?: string;
  type?: number;
  phone?: string;
  applicableType?: number;
  partner?: string;
  provider?: string;
  reason?: string;
  transactions?: Array<TransactionHistoryResponseModel>;

  constructor(data?: Partial<BalanceHistoryActionEntity>) {
    this.code = data?.code;
    this.status = data?.status;
    this.amount = data?.amount;
    this.type = data?.type;
    this.phone = data?.phone;
    this.applicableType = data?.applicableType;
    this.partner = data?.partner;
    this.provider = data?.provider;
    this.reason = data?.reason;
    this.transactions = data?.transactions;
  }

  includeAmount?() {
    return this.status !== 3;
  }

  includeTransaction?() {
    return this.transactions && !isEmpty(this.transactions);
  }

  isValidAmount?(amount: number | string) {
    return Number(amount) > 0;
  }
}
